import { differenceBy, filter, isEqual, map } from 'lodash';
import { reaction } from 'mobx';
import React, { useEffect } from 'react';
import { FB, FBSchemaProps, FBSectionTypes } from '..';

const FBWorkspaceAutosave: React.FC<{ schema?: FBSchemaProps[] }> = ({ schema }) => {
  const { workspaceState, formState, bookmarkState } = FB.useStores();

  // Initialize before subscribing so loading a schema is not treated as an edit.
  useEffect(() => {
    const isNormalized = schema?.every((item, index) => item.index === index) ?? true;
    if (isNormalized && isEqual(workspaceState?.schema, schema)) { return; }
    const schemaDiff = differenceBy(workspaceState?.schema, schema ?? [], 'name');
    const sections = filter(schemaDiff, (item) => item.type && FBSectionTypes.includes(item.type));
    bookmarkState?.removeBookmarks(map(sections, 'name'));
    workspaceState?.initSchema(schema);
  }, [schema, workspaceState, bookmarkState]);

  useEffect(() => reaction(
    () => workspaceState?.schema,
    () => {
      if (!workspaceState || !['design', 'formDesign'].includes(workspaceState.mode)) { return; }
      workspaceState.scheduleDocRev(
        workspaceState.shouldPersistFormDataWithSchema && formState ? () => {
          formState.flushChangeValidation();
          return formState.getValues();
        } : undefined,
      );
    },
  ), [workspaceState, formState]);

  useEffect(() => workspaceState?.registerAutosaveOwner(), [workspaceState]);

  return null;
};

export default FBWorkspaceAutosave;
